/**
 * MivaSkin scroll-reveal.
 * Fades/slides elements marked [data-mivaskin-animate] into place the
 * first time they scroll into view. No-ops entirely for anyone with
 * prefers-reduced-motion set — everything is just visible immediately.
 */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('[data-mivaskin-animate]');

  if (!targets.length) return;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('mivaskin-in-view');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mivaskin-in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
